const isSquare = () => window.partner === "square" || window.location.pathname.slice(0, 7) === "/square";

export default isSquare;
